import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer
} from "recharts";

export default function CAEvolutionLineChart({ data }) {
  return (
    <div style={{ width: "100%", height: 400 }}>
      <ResponsiveContainer>
        <LineChart data={data}>
          <CartesianGrid strokeDasharray="3 3" vertical={false} />
          <XAxis dataKey="year" />
          <YAxis
            label={{
              value: "€ / client",
              angle: -90,
              position: "insideLeft"
            }}
          />
          <Tooltip formatter={(value) => `${value.toLocaleString()} €`} />
          <Legend verticalAlign="bottom" iconType="circle" height={36} />

          <Line
            type="monotone"
            dataKey="new"
            stroke="#34a853"
            strokeWidth={2}
            dot={{ r: 4 }}
            name="Entrants"
          />
          <Line
            type="monotone"
            dataKey="followup"
            stroke="#4285f4"
            strokeWidth={2}
            dot={{ r: 4 }}
            name="À Suivre"
          />
          <Line
            type="monotone"
            dataKey="leaving"
            stroke="#fbbc05"
            strokeWidth={2}
            dot={{ r: 4 }}
            name="En Partance"
          />
          <Line
            type="monotone"
            dataKey="recovered"
            stroke="#9c27b0"
            strokeWidth={2}
            dot={{ r: 4 }}
            name="Récupérés"
          />
          <Line
            type="monotone"
            dataKey="old"
            stroke="#ef5350"
            strokeWidth={2}
            dot={{ r: 4 }}
            name="Sortants"
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
